<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
    <mat-expansion-panel-header class="disable_ripple">
        <mat-panel-title>
            <div *ngIf="this.frmInterviewee.errors?.['required']==null">
                <b>INTERVIEWEE </b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Interviewee_Overview'"></help-text-btn>
            </div>
            <div *ngIf="this.frmInterviewee.errors?.['required']">
                <b style="color: red;">INTERVIEWEE (incomplete)</b>
            </div>
        </mat-panel-title>

    </mat-expansion-panel-header>

    <form [formGroup]="frmInterviewee">

        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input matInput type="string" placeholder="First Name" formControlName="fName" />
                    <mat-error *ngIf="fName.invalid">Enter First Name</mat-error>
                </mat-form-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input matInput type="string" placeholder="Last Name" formControlName="lName" />
                    <mat-error *ngIf="lName.invalid">Enter Last Name</mat-error>
                </mat-form-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                <mat-form-field>
                    <mat-label>Relation to the child</mat-label>
                    <mat-select [formControl]="relationChild" required (focusout)="updateChangeValue()">
                        <mat-option *ngFor="let relationChild of relationShipData" [value]="relationChild.name">
                            {{relationChild.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="relationChild.hasError('required')">Please choose relationship to
                        child</mat-error>
                </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                <mat-form-field>
                    <mat-label>MM/DD/YY</mat-label>
                    <input matInput type="string" placeholder="MM/DD/YY" required formControlName="intervieweeDate"
                        (focusout)="updateChangeValue()" />
                </mat-form-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3" *ngIf="this.action==1 || this.action==2">
                <div class="row">
                    <div class="col">
                        <button mat-flat-button color="primary" style="width: 100%;"  mat-raised-button (click)="copySignature('g1')">Copy
                            Parent/Guardian 1</button>
                    </div>
                </div>
                <div class="row" style="padding-top: 6px">
                    <div class="col">
                        <button mat-flat-button color="primary" style="width: 100%;" mat-raised-button (click)="copySignature('g2')">Copy
                            Parent/Guardian 2</button>
                    </div>
                </div>
                <div class="row" style="padding-top: 6px">
                    <div class="col">                        
                        <button mat-flat-button color="primary" style="width: 100%;"  mat-raised-button (click)="copySignature('osy')">
                            Copy OSY </button>
                        
                    </div>
                
                </div>
            </div>    
        </div>

        <div class="row" style="padding-top: 10px;">
            <div *ngIf="fName.valid && lName.valid && intervieweeDate.invalid" 
                class="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-2">
                <button style="width: 100%;" mat-flat-button color="primary" (click)="populateNameDate()">
                    Add date
                </button>
            </div>
            <div *ngIf="fName.valid && lName.valid" 
                class="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-2">
                <button style="width: 100%;" mat-flat-button color="warn" (click)="clearNameDate()">
                    Clear
                </button>
            </div>

            <div class="col-lg-4 col-xl-8">

            </div>
        </div>

    </form>

    <div class="row" style="padding-top: 30px" *ngIf="(action==2 || action==3) ">
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Past Edit - {{this.trackHistories.inaHistory.length}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="this.trackHistories.inaHistory.length>=1">
                    <app-past-edit [section]="this.section"></app-past-edit>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

</mat-expansion-panel>